import Axios from '@/utils/axios';
import Api from '@/constant/api';

export const getNotice = async (params) => {
  return Axios.jsonGet(Api.notice.getNotice, { params });
};

export const saveContent = async (body) => {
  return Axios.jsonPost(Api.notice.saveContent, body);
};
